import React, { useState } from "react";
import { Btn, ToolTip } from "../../../../AbstractElements";
import { BasicTooltips, MagicPleaseHoverMe } from "../../../../Constant";
import { InlineTooltip } from "./InlineTooltip";
import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { BASIC_TOOLTIP_DATA } from "../../../../Data/UiKit/Tooltip";

const BasicTooltip = () => {
  const [basictooltip, setbasictooltip] = useState(false);
  const toggle = () => setbasictooltip(!basictooltip);
  return (
    <Col sm="12">
      <Card>
        <CommonCardHeader title={BasicTooltips} span={BASIC_TOOLTIP_DATA} />
        <CardBody>
          <Btn color="primary" className="example-popover mb-0 me-0" id="Tooltip-1">{MagicPleaseHoverMe}</Btn>
          <ToolTip target="Tooltip-1" placement="top" isOpen={basictooltip} toggle={toggle}>
            Surprise!!! Thank you for hovering...
          </ToolTip>
          <InlineTooltip />
        </CardBody>
      </Card>
    </Col>
  );
};

export default BasicTooltip;
